import React, { useEffect, useState } from "react";
import axios from "axios";
import { MyPieChart } from "../pieChart";
import "../../dashboardStyle/dashStock.css";

import { Dialog } from 'primereact/dialog';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { TabView, TabPanel } from 'primereact/tabview';



import HelpIcon from '@mui/icons-material/Help';

export const DashETG = ({ dim }) => {
  
  const apiUrl = process.env.REACT_APP_API_URL;

  const [visible, setVisible] = useState(false);
  
     const [totalStockagesEtg,setTotalStockagesEtg] = useState(0);
     const [stockagesOccupesEtg,setStockagesOccupesEtg] = useState(0);
     const [stockagesLibresEtg,setStockagesLibresEtg] = useState(0);
  
   const [error, setError] = useState(null);

    const [infosLibres, setInfosLibres] = useState([]);
     const [infosOccupes, setInfosOccupes] = useState([]);


     useEffect(() => {
       axios
         .get(`${apiUrl}/IHM/api/infoDashboard.php?Libres=ETAGE`)
         .then((response) => {
           setInfosLibres(response.data);
         })
         .catch((error) => {
           console.error(
             "Erreur lors du chargement des fiches abandonnées :",
             error
           );
         });
     }, []);
     
     useEffect(() => {
       axios
         .get(`${apiUrl}/IHM/api/infoDashboard.php?Occupes=ETAGE`)
         .then((response) => {
           setInfosOccupes(response.data);
         })
         .catch((error) => {
           console.error(
             "Erreur lors du chargement des fiches abandonnées :",
             error
           );
         });
     }, []);

  useEffect(() => {
      const fetchData = async () => {
        try {
          const response = await axios.post(`${apiUrl}IHM/api/dashboard.php?box=etg`);
          if (response.data) {
            setTotalStockagesEtg(response.data.totalStockages);
            setStockagesOccupesEtg(response.data.stockagesOccupes);
            setStockagesLibresEtg(response.data.stockagesLibres);
          } else {
            console.error("La réponse de l'API n'est pas valide:", response.data);
            
          }
        } catch (error) {
          console.error("Erreur lors de la récupération des données:", error);
       
        }
      };
  
      fetchData();
    }, [apiUrl]);

  if (error) {
    return <div>{error}</div>;
  }

   const occupEtg = stockagesOccupesEtg;
  const libreEtg = stockagesLibresEtg;


  return (
    <>
      <Dialog
        header="Etage"
        visible={visible}
        style={{ width: "70vw" }}
        onHide={() => {
          if (!visible) return;
          setVisible(false);
        }}
      >
        <TabView>
          <TabPanel header="Libres">
            <DataTable
              value={infosLibres}
              paginator
              rows={10}
              rowsPerPageOptions={[5, 10, 25, 50]}
              size="small"
              paginatorRight={
                <span style={{ margin: "10px", fontWeight: "bold" }}>
                  Résultats : {infosLibres.length}
                </span>
              }
              paginatorTemplate={
                "FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
              }
            >
              <Column header="N°" field="idStockage" />

              <Column header=" Volume (m³)" field="vol" />
            </DataTable>
          </TabPanel>

          <TabPanel header="Occupés">
            <DataTable
              value={infosOccupes}
              paginator
              rows={10}
              rowsPerPageOptions={[5, 10, 25, 50]}
              size="small"
              paginatorRight={
                <span style={{ margin: "10px", fontWeight: "bold" }}>
                  Résultats : {infosOccupes.length}
                </span>
              }
              paginatorTemplate={
                "FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
              }
            >
              <Column header="N°" field="idStockage" />

              <Column header=" Volume (m³)" field="vol" />

              <Column header="Client" field="nom" />
            </DataTable>
          </TabPanel>
        </TabView>
      </Dialog>

      <div
        style={{
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div
          style={{
            fontWeight: "600",
            fontSize: "18px",
            marginBottom: "10px",
          }}
        >
          <span
            style={{ fontWeight: "600", cursor: "pointer", zIndex: "22" }}
            onClick={() => setVisible(true)}
          >
            Etage <HelpIcon sx={{ fontSize: 14 }} />
          </span>
        </div>
        <MyPieChart data={[occupEtg, libreEtg]} dim={dim} />
      </div>
    </>
  );
};